<template>
  <main class="legal-page">
    <article class="legal-page__content">
      <slot></slot>
    </article>
  </main>
</template>

<script>
export default {
  name: 'LegalPage'
}
</script>

<style scoped>
.legal-page {
  box-sizing: border-box;
  height: 100vh;
  padding: 40px 24px 64px;
  overflow-x: hidden;
  overflow-y: auto;
  color: #333;
  background: #fff;
}

.legal-page__content {
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  font-size: 16px;
  line-height: 1.85;
}

.legal-page__content /deep/ h1 {
  margin: 0 0 28px;
  color: #222;
  font-size: 28px;
  line-height: 1.4;
  text-align: center;
}

.legal-page__content /deep/ h2 {
  margin: 30px 0 12px;
  color: #222;
  font-size: 20px;
  line-height: 1.5;
  text-align: left;
}

.legal-page__content /deep/ h3 {
  margin: 22px 0 10px;
  color: #222;
  font-size: 18px;
  line-height: 1.5;
}

.legal-page__content /deep/ p {
  margin: 0 0 14px;
  line-height: inherit;
  text-align: justify;
}

.legal-page__content /deep/ .legal-page__meta {
  margin-bottom: 24px;
  color: #666;
  text-align: center;
}

.legal-page__content /deep/ .legal-page__meta p {
  margin-bottom: 2px;
  text-align: center;
}

.legal-page__content /deep/ ol {
  margin: 0;
  padding-left: 28px;
}

.legal-page__content /deep/ li {
  margin-bottom: 14px;
  padding-left: 4px;
}

.legal-page__content /deep/ ul {
  margin: 0 0 14px;
  padding-left: 28px;
}

.legal-page__content /deep/ ul li {
  list-style: disc;
}

.legal-page__content /deep/ .legal-page__table {
  width: 100%;
  margin: 18px 0 24px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.legal-page__content /deep/ table {
  width: 100%;
  min-width: 860px;
  border-collapse: collapse;
  background: #fff;
}

.legal-page__content /deep/ th,
.legal-page__content /deep/ td {
  padding: 12px 14px;
  border: 1px solid #ddd;
  line-height: 1.65;
  text-align: left;
  vertical-align: top;
}

.legal-page__content /deep/ th {
  color: #222;
  font-weight: 600;
  background: #f6f7f9;
}

.legal-page__content /deep/ a {
  color: #2f6feb;
  text-decoration: none;
}

.legal-page__content /deep/ a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .legal-page {
    padding: 24px 16px 44px;
  }

  .legal-page__content {
    font-size: 15px;
    line-height: 1.75;
  }

  .legal-page__content /deep/ h1 {
    margin-bottom: 22px;
    font-size: 23px;
  }

  .legal-page__content /deep/ h2 {
    margin-top: 24px;
    font-size: 18px;
  }

  .legal-page__content /deep/ h3 {
    margin-top: 20px;
    font-size: 16px;
  }

  .legal-page__content /deep/ th,
  .legal-page__content /deep/ td {
    padding: 10px 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/legal/LegalPage.vue